// Populate this array with real projects once available. The Results and
// Work pages automatically render an empty state until entries exist.
export const caseStudies = [];

export const workFilters = ["ALL", "BRANDING", "MARKETING", "WEB", "GROWTH", "AUTOMATION"];
